"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight, Loader2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function InquiryFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="10727" className="flex flex-col items-center justify-center h-full min-h-[400px] text-center p-8 bg-accent/20 border border-primary/30 rounded-xl animate-in fade-in zoom-in duration-500">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
          <ArrowRight className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-2xl font-serif font-bold text-foreground mb-2">Inquiry Received</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
      </div>;
  }
  return <Form className="space-y-8" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {}
        <FormField control={control} name="full_name" rules={{
        required: "Full Name is required"
      }} render={({
        field
      }) => <FormItem className="relative z-0 w-full group">
              <FormControl>
                <input type="text" placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer transition-colors duration-300 font-sans" {...field} />
              </FormControl>
              <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Full Name
              </FormLabel>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem className="relative z-0 w-full group">
              <FormControl>
                <input type="email" placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer transition-colors duration-300 font-sans" {...field} />
              </FormControl>
              <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Email Address
              </FormLabel>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {}
        <FormField control={control} name="phone" rules={{
        pattern: {
          value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
          message: "Invalid phone number"
        }
      }} render={({
        field
      }) => <FormItem className="relative z-0 w-full group">
              <FormControl>
                <input type="tel" placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer transition-colors duration-300 font-sans" {...field} />
              </FormControl>
              <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Phone Number (Optional)
              </FormLabel>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="company" render={({
        field
      }) => <FormItem className="relative z-0 w-full group">
              <FormControl>
                <input type="text" placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer transition-colors duration-300 font-sans" {...field} />
              </FormControl>
              <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Company / Organization
              </FormLabel>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem className="relative z-0 w-full group">
            <FormControl>
              <input type="text" placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer transition-colors duration-300 font-sans" {...field} />
            </FormControl>
            <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
              Subject
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem className="relative z-0 w-full group">
            <FormControl>
              <textarea rows={4} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-foreground bg-transparent border-0 border-b-2 border-input appearance-none focus:outline-none focus:ring-0 focus:border-primary peer resize-none transition-colors duration-300 font-sans" {...field} />
            </FormControl>
            <FormLabel className="peer-focus:font-medium absolute text-sm text-muted-foreground duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
              Message
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto rounded-md bg-primary text-primary-foreground hover:bg-[#00928a] font-bold px-8 py-6 text-base transition-all duration-300">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 h-5 w-5" />
            Processing...
          </> : <>
            Submit Inquiry
            <ArrowRight className="ml-2 h-5 w-5" />
          </>}
      </Button>
    </Form>;
}
export default function InquiryForm() {
  return;
}